import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
};

export const useGetV4AdvReportByDate = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, group, preStart, preEnd } = useDates();
  return (params: Params) => {
    const search = params.search ? params.search.split(",") : [];
    return queryOptions({
      queryKey: [{ entity: "V4AdvReportByDate", marketPlace, params, dates: { start, end, preStart, preEnd, group } }],
      queryFn: async () =>
        await apiClient.getV4AdvReportByDate({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(params.filters),
            date_group: group,
            search,
          },
        }),
    });
  };
};
